module.exports = __webpack_public_path__ + "img/non-smoker-selected.35790f1a.svg";